export const extractCategoriesFromMap = (categories) => {
    const categoryList = Array.isArray(categories) ? categories : (categories?.categories ?? []);
    return (
        categoryList.reduce((acc, category) => {
            if (typeof category === 'string') {
                acc.push({ name: category });
                return acc;
            }

            const name = category?.name || category?.key;
            if (name) {
                acc.push({ name });
            }
            return acc;
        }, []) ?? []
    );
};
